import { render, staticRenderFns } from "./app-breadcrumb.vue?vue&type=template&id=8b71275a&"
import script from "./app-breadcrumb.vue?vue&type=script&lang=ts&"
export * from "./app-breadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./app-breadcrumb.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports